export interface RelatedServiceItem {
  title: string;
  href: string;
  description: string;
  icon: string;
}

export default function RelatedServices({
  items,
}: {
  items: RelatedServiceItem[];
}) {
  return (
    <section id="related" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            RELATED SERVICES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            関連<span className="text-primary-500">サービス</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都ゴミ処分センターでは、不用品回収・遺品整理・ゴミ屋敷清掃を一社で完結して対応しています。
            お困りの内容に合わせて、こちらもご覧ください。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {items.map((it) => (
            <a
              key={it.href}
              href={it.href}
              className="group flex items-start gap-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 p-6 md:p-8 cursor-pointer transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 shrink-0">
                <i className={`${it.icon} text-primary-600 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {it.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {it.description}
                </p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-primary-600">
                  詳しく見る
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}